import {Plugins, Component} from '@packages/systems/wfdl';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {
  EElement,
  EDistinct,
  EText,
  ERecord,
  EBoolean,
  EEnum,
  EList,
  ELiteral,
} from '@packages/systems/wfdl-ast';

import {images} from '../constants';

export const LayoutFeaturesList = {
  factory: EElement({
    id: '0576792d-6fde-b1e8-7be2-9161118de90c',
    type: qualify(Plugins.name('Layout'), Component.name('Section')),
    data: ERecord({
      grid: ERecord({
        type: EText('section'),
      }),
      tag: EEnum('section'),
      styleBlockIds: EList([EText('eb4b1ed9-2346-59f0-7f55-bb9c61ca10df')]),
      children: EList([
        EElement({
          id: '0576792d-6fde-b1e8-7be2-9161118de90d',
          type: qualify(Plugins.name('Basic'), Component.name('Block')),
          data: ERecord({
            tag: EEnum('div'),
            text: EBoolean(false),
            styleBlockIds: EList([
              EText('81b59867-fdee-430e-3436-1014d50622b3'),
            ]),
            children: EList([
              EElement({
                id: '6b6a3797-732d-1539-d467-d8adef2343d7',
                type: qualify(Plugins.name('Basic'), Component.name('Block')),
                data: ERecord({
                  tag: EEnum('div'),
                  text: EBoolean(false),
                  styleBlockIds: EList([
                    EText('27b4562b-4f7b-bc2d-416e-e550d5063631'),
                  ]),
                  children: EList([
                    EElement({
                      id: 'd2c83161-8530-e677-42f3-8e55b9e56eac',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('Block')
                      ),
                      data: ERecord({
                        tag: EEnum('div'),
                        text: EBoolean(false),
                        styleBlockIds: EList([
                          EText('c7fd11f4-f02d-f844-b1bd-5f0e8b405806'),
                        ]),
                        children: EList([
                          EElement({
                            id: 'ce95b884-caaa-d561-384e-4187f876807d',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Heading')
                            ),
                            data: ERecord({
                              tag: EEnum('h3'),
                              children: EList([
                                EElement({
                                  id: 'ce95b884-caaa-d561-384e-4187f876807e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText('Features section'),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '8b90b8f3-15fd-e916-b9fd-e2711101bc39',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Paragraph')
                            ),
                            data: ERecord({
                              styleBlockIds: EList([
                                EText('a0365759-7aae-10cc-1292-91eb49a8f246'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '8b90b8f3-15fd-e916-b9fd-e2711101bc3a',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('String')
                                  ),
                                  data: EText(
                                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros. Quisque quis euismod lorem. Etiam sodales ac felis id interdum.'
                                  ),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '69b9f3c4-cd22-3756-995e-2cd3192b0b3a',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('Link')
                            ),
                            data: ERecord({
                              button: EBoolean(false),
                              block: EText('inline'),
                              eventIds: EList([]),
                              link: ELiteral({
                                name: qualify(
                                  Plugins.name('Basic'),
                                  typeName('Link')
                                ),
                                value: JSON.parse(
                                  '{"mode":"external","url":"#"}'
                                ),
                              }),
                              styleBlockIds: EList([
                                EText('8829443b-f005-1554-a272-e89504531e07'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '69b9f3c4-cd22-3756-995e-2cd3192b0b3b',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Block')
                                  ),
                                  data: ERecord({
                                    text: EBoolean(true),
                                    tag: EEnum('div'),
                                    children: EList([
                                      EElement({
                                        id: '69b9f3c4-cd22-3756-995e-2cd3192b0b3c',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText('Learn more'),
                                      }),
                                    ]),
                                  }),
                                }),
                                EElement({
                                  id: '69b9f3c4-cd22-3756-995e-2cd3192b0b3d',
                                  type: qualify(
                                    Plugins.name('Embed'),
                                    Component.name('HtmlEmbed')
                                  ),
                                  data: ERecord({
                                    embed: ERecord({
                                      type: EText('html'),
                                      meta: ERecord({
                                        html: EText(
                                          '<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M11.13 8.5L6.87296 4.24291L5.87067 5.24379L9.129 8.5L5.87067 11.7555L6.87225 12.7571L11.13 8.5Z" fill="currentColor"/>\n</svg>'
                                        ),
                                        div: EBoolean(false),
                                        iframe: EBoolean(false),
                                        script: EBoolean(false),
                                        compilable: EBoolean(false),
                                      }),
                                    }),
                                    insideRTE: EBoolean(false),
                                    styleBlockIds: EList([
                                      EText(
                                        '6cdfed94-50ee-a092-b160-1f9b110b78cb'
                                      ),
                                    ]),
                                    value: EText(
                                      '<svg width="17" height="17" viewbox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">\n<path d="M11.13 8.5L6.87296 4.24291L5.87067 5.24379L9.129 8.5L5.87067 11.7555L6.87225 12.7571L11.13 8.5Z" fill="currentColor"/>\n</svg>'
                                    ),
                                    content: EDistinct({
                                      name: qualify(
                                        Plugins.name('Embed'),
                                        typeName('CodeProp')
                                      ),
                                      value: EText(''),
                                    }),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                    EElement({
                      id: '489e471b-da9a-43fc-cec9-0fd3b1546fca',
                      type: qualify(
                        Plugins.name('Basic'),
                        Component.name('List')
                      ),
                      data: ERecord({
                        tag: EEnum('ul'),
                        list: ERecord({
                          type: EText('list'),
                          unstyled: EBoolean(true),
                        }),
                        styleBlockIds: EList([
                          EText('bef5a5ff-1e5f-c7f9-44bc-c0508f445bf7'),
                        ]),
                        children: EList([
                          EElement({
                            id: '489e471b-da9a-43fc-cec9-0fd3b1546fcb',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('ListItem')
                            ),
                            data: ERecord({
                              list: ERecord({
                                type: EText('item'),
                              }),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('190fd48a-2606-64ec-a9ae-4a709e4b00ef'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '555fdf0c-4212-b37f-35ea-8f774c4081dc',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageHills),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62737d2d7a06d0ed28006e3b"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '395c8832-544c-8108-78f3-b8a705bcdeb5'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '555fdf0c-4212-b37f-35ea-8f774c4081dd',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Paragraph')
                                  ),
                                  data: ERecord({
                                    children: EList([
                                      EElement({
                                        id: '555fdf0c-4212-b37f-35ea-8f774c4081de',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText(
                                          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros.'
                                        ),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '489e471b-da9a-43fc-cec9-0fd3b1546fcc',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('ListItem')
                            ),
                            data: ERecord({
                              list: ERecord({
                                type: EText('item'),
                              }),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('190fd48a-2606-64ec-a9ae-4a709e4b00ef'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '8171c6b8-c040-e165-4d91-b0d742a7502d',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(images.placeholderImageCards),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62737d2d7a06d0ed28006e36"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '395c8832-544c-8108-78f3-b8a705bcdeb5'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '8171c6b8-c040-e165-4d91-b0d742a7502e',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Paragraph')
                                  ),
                                  data: ERecord({
                                    children: EList([
                                      EElement({
                                        id: '8171c6b8-c040-e165-4d91-b0d742a7502f',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText(
                                          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros.'
                                        ),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                          EElement({
                            id: '489e471b-da9a-43fc-cec9-0fd3b1546fcd',
                            type: qualify(
                              Plugins.name('Basic'),
                              Component.name('ListItem')
                            ),
                            data: ERecord({
                              list: ERecord({
                                type: EText('item'),
                              }),
                              text: EBoolean(false),
                              styleBlockIds: EList([
                                EText('190fd48a-2606-64ec-a9ae-4a709e4b00ef'),
                              ]),
                              children: EList([
                                EElement({
                                  id: '4cae7720-e1cf-313a-3b72-74aa64b300bd',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Image')
                                  ),
                                  data: ERecord({
                                    attr: ERecord({
                                      src: EText(
                                        images.placeholderImageGallery
                                      ),
                                      loading: EEnum('lazy'),
                                      width: EText('auto'),
                                      height: EText('auto'),
                                      alt: EText('__wf_reserved_inherit'),
                                    }),
                                    img: ELiteral({
                                      name: qualify(
                                        Plugins.name('Asset'),
                                        typeName('Image')
                                      ),
                                      value: JSON.parse(
                                        '{"id":"62737d2d7a06d0ed28006e3e"}'
                                      ),
                                    }),
                                    styleBlockIds: EList([
                                      EText(
                                        '395c8832-544c-8108-78f3-b8a705bcdeb5'
                                      ),
                                    ]),
                                    temp: ERecord({
                                      img: ERecord({
                                        src: EText(''),
                                      }),
                                    }),
                                    srcsetDisabled: EBoolean(false),
                                    sizes: EList([]),
                                  }),
                                }),
                                EElement({
                                  id: '4cae7720-e1cf-313a-3b72-74aa64b300be',
                                  type: qualify(
                                    Plugins.name('Basic'),
                                    Component.name('Paragraph')
                                  ),
                                  data: ERecord({
                                    children: EList([
                                      EElement({
                                        id: '4cae7720-e1cf-313a-3b72-74aa64b300bf',
                                        type: qualify(
                                          Plugins.name('Basic'),
                                          Component.name('String')
                                        ),
                                        data: EText(
                                          'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse tincidunt sagittis eros.'
                                        ),
                                      }),
                                    ]),
                                  }),
                                }),
                              ]),
                            }),
                          }),
                        ]),
                      }),
                    }),
                  ]),
                }),
              }),
            ]),
          }),
        }),
      ]),
    }),
  }),
  styleBlocks: [
    {
      _id: 'eb4b1ed9-2346-59f0-7f55-bb9c61ca10df',
      type: 'class',
      name: 'Features List',
      comb: '',
      styleLess:
        'position: relative; padding-top: 80px; padding-right: 30px; padding-bottom: 80px; padding-left: 30px; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: hsla(212.00000000000006, 38.46%, 92.35%, 1.00);',
      children: [],
      variants: {
        small: {
          styleLess:
            'padding-top: 60px; padding-right: 15px; padding-bottom: 60px; padding-left: 15px;',
        },
      },
    },
    {
      _id: '81b59867-fdee-430e-3436-1014d50622b3',
      type: 'class',
      name: 'Container',
      comb: '',
      styleLess:
        'width: 100%; max-width: 940px; margin-right: auto; margin-left: auto;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 728px;'},
        tiny: {styleLess: 'max-width: none;'},
      },
    },
    {
      _id: '27b4562b-4f7b-bc2d-416e-e550d5063631',
      type: 'class',
      name: 'Features Wrapper Two',
      comb: '',
      styleLess:
        'display: flex; justify-content: space-between; align-items: flex-start;',
      children: [],
      variants: {
        medium: {
          styleLess:
            'flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: 'c7fd11f4-f02d-f844-b1bd-5f0e8b405806',
      type: 'class',
      name: 'Features Left',
      comb: '',
      styleLess:
        'display: flex; max-width: 40%; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
      children: [],
      variants: {medium: {styleLess: 'max-width: 100%; margin-bottom: 40px;'}},
    },
    {
      _id: 'a0365759-7aae-10cc-1292-91eb49a8f246',
      type: 'class',
      name: 'Features Paragraph',
      comb: '',
      styleLess: 'margin-bottom: 24px;',
      children: [],
      variants: {},
    },
    {
      _id: '8829443b-f005-1554-a272-e89504531e07',
      type: 'class',
      name: 'Text Link Arrow',
      comb: '',
      styleLess:
        'display: flex; justify-content: flex-start; align-items: center; color: #1a1b1f; font-size: 14px; line-height: 20px; text-decoration: none;',
      children: [],
      variants: {},
    },
    {
      _id: '6cdfed94-50ee-a092-b160-1f9b110b78cb',
      type: 'class',
      name: 'Arrow Embed',
      comb: '',
      styleLess: 'display: flex; margin-left: 2px;',
      children: [],
      variants: {},
    },
    {
      _id: 'bef5a5ff-1e5f-c7f9-44bc-c0508f445bf7',
      type: 'class',
      name: 'Features Right',
      comb: '',
      styleLess:
        'display: flex; max-width: 46%; margin-bottom: -16px; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
      children: [],
      variants: {
        medium: {styleLess: 'max-width: 100%;'},
        tiny: {styleLess: 'margin-bottom: -30px;'},
      },
    },
    {
      _id: '190fd48a-2606-64ec-a9ae-4a709e4b00ef',
      type: 'class',
      name: 'Features Block Two',
      comb: '',
      styleLess:
        'display: flex; margin-bottom: 16px; justify-content: flex-start; align-items: center;',
      children: [],
      variants: {
        tiny: {
          styleLess:
            'margin-bottom: 30px; flex-direction: column; justify-content: flex-start; align-items: flex-start;',
        },
      },
    },
    {
      _id: '395c8832-544c-8108-78f3-b8a705bcdeb5',
      type: 'class',
      name: 'Features Image',
      comb: '',
      styleLess:
        'width: 80px; height: 80px; margin-right: 16px; object-fit: cover;',
      children: [],
      variants: {tiny: {styleLess: 'margin-bottom: 10px;'}},
    },
  ],
} as const;
